import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { CheckSquare, Square } from "react-feather";

// material UI theme and tailwind css
import "./styles/tailwind.css";
import theme from "./styles/theme";

// translations from i18n
import i18n from "./i18n";

// routing config from react-router-dom
import router from "./routes";
import NotFoundPage from "./pages/NotFoundPage";
import { CustomSnackBarProvider } from "./contexts/CustomSnackBarContext";

theme.components = {
  MuiCheckbox: {
    defaultProps: {
      icon: <Square size={24} />,
      checkedIcon: <CheckSquare size={24} />
    }
  }
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <CustomSnackBarProvider>
          <RouterProvider router={router} fallbackElement={<NotFoundPage />} />
        </CustomSnackBarProvider>
      </I18nextProvider>
    </ThemeProvider>
  );
}

export default App;
